<div class="b2a-vidContainer" [ngClass]="{'vidContainerFull': fullScreened === true}" #vidContainer>

  <video autoplay playsinline id="video" #videoPlayer (timeupdate)="seekBarUpdate()">
    <source [src]="video" type="video/mp4"/>
    <track [src]="captionObjectUrl" kind="subtitles" srclang="de" label="Deutsch">
    {{'PLAYER.ALERT.unsupportedBrowser' | translate}}
  </video>

  <div class="b2a-vidContainer__inner" (mousemove)="mouseOver($event)" (mouseout)="mouseOut($event)" [ngClass]="{'showInnerContainer': showOverlay || videoEnded || pausedVideo}">

    <div id="overlay"></div>

    <div class="b2a-vidContainer__inner__center" (click)="playPause()">
        <ng-content select=[videoInfo]></ng-content>

        <img *ngIf="pausedVideo && !videoEnded"
          src="assets/icons/video/48x48/play-48.svg"
          onerror="this.style.display='none'"
          class="b2a-vidContainer__inner__center_play"
          alt="{{'PLAYER.altPlay' | translate }} Video"
          title="{{'PLAYER.altPlay' | translate }}"/>
        <img *ngIf="!pausedVideo && !videoEnded"
          src="assets/icons/video/48x48/pause-48.svg"
          onerror="this.style.display='none'"
          class="b2a-vidContainer__inner__center_pause"
          alt="{{'PLAYER.altPause' | translate }} Video"
          title="{{'PLAYER.altPause' | translate }}"/>
        <img *ngIf="videoEnded"
          src="assets/icons/video/48x48/repeat-48.svg"
          onerror="this.style.display='none'"
          class="b2a-vidContainer__inner__center_repeat"
          alt="{{'PLAYER.altRepeat' | translate }}"
          title="{{'PLAYER.altPause' | translate }}"/>

        <div (click)="nextExercise($event)">
          <ng-content select=[nextVideoScreen] *ngIf="videoEnded && isNextEnabled" ></ng-content>
        </div>
        <div (click)="nextExercise($event)">
            <ng-content select=[lastVideoScreen] *ngIf="videoEnded && isLastVideo" ></ng-content>
        </div>
    </div>

    <div class="b2a-vidContainer__inner__bar">
      <div class="b2a-vidContainer__inner__bar__progress">
        <div class="bar">
          <input type="range" step="0.001" (change)="seekBar($event)" min="0" max="100" id="Video-Progress">

          <div class="track"><div class="track-fill" [ngStyle]="{'width.%':seekbarProgress}"></div></div>
        </div>
        <label for="Video-Progress" class="time">{{now | duration}}</label>
      </div>

      <div class="b2a-vidContainer__inner__bar__buttonRow">

        <div class="firstContainer">
          <div class="b2a-vidContainer__inner__bar__buttonRow__icon" (click)="playPause()">
            <img *ngIf="pausedVideo || videoEnded"
                 src="assets/icons/video/24x24/play.svg"
                 onerror="this.style.display='none'"
                 alt="{{'PLAYER.altPlay' | translate }} Video"
                 title="{{'PLAYER.altPlay' | translate }}"/>
            <img *ngIf="!pausedVideo && !videoEnded"
                 src="assets/icons/video/24x24/pause.svg"
                 onerror="this.style.display='none'"
                 alt="{{'PLAYER.altPause' | translate }} Video"
                 title="{{'PLAYER.altPause' | translate }}"/>
          </div>
          <div class="b2a-vidContainer__inner__bar__buttonRow__icon" (click)="mute()">
            <img *ngIf="volumeSlider.value >  .6 && !isMuted" src="assets/icons/video/24x24/volume-high.png" onerror="this.style.display='none'" alt="{{'PLAYER.altVolumeHigh' | translate }}"/>
            <img *ngIf="volumeSlider.value <= .6 && volumeSlider.value > 0 && !isMuted" src="assets/icons/video/24x24/volume-low.png" onerror="this.style.display='none'" alt="{{'PLAYER.altVolumeLow' | translate }}"/>
            <img *ngIf="volumeSlider.value == 0 || isMuted" src="assets/icons/video/24x24/volume-mute.png" onerror="this.style.display='none'" alt="{{'PLAYER.altVolumeMute' | translate }}"/>
          </div>
          <div class="b2a-vidContainer__inner__bar__buttonRow__icon">
            <mat-slider #volumeSlider value="1" id="volume" min="0" max="1" step="0.01" (input)="volumeBar($event)"></mat-slider>
          </div>
          <div class="newEx b2a-vidContainer__inner__bar__buttonRow__icon__group" [ngClass]="{'disabled': videoEnded === true}" *ngIf="isShuffleEnabled"
               (click)="newExercise($event)">
            <div class="b2a-vidContainer__inner__bar__buttonRow__icon">
              <img src="assets/icons/video/24x24/restart.svg"
                 onerror="this.style.display='none'"/>
            </div>
            {{'PLAYER.changeExerciseBtn' | translate}}
          </div>
        </div>
        <div class="secondContainer">
          <div id="caption" (click)="toggleCaption()" [ngClass]="{'disabled': !captionObjectUrl}">
            <img src="assets/icons/video/24x24/caption.svg"
                 onerror="this.style.display='none'"
                 alt="{{'PLAYER.altCaption' | translate}} Toggle"
                 title="{{'PLAYER.altCaption' | translate}}"/>
            <div *ngIf="captionActive" class="active"></div>
          </div>
          <div id="fullscreen" (click)="toggleFullScreen()">
            <img src="assets/icons/video/24x24/full.png"
                 onerror="this.style.display='none'"
                 alt="{{'PLAYER.altFullscreen' | translate}} Toggle"
                 title="{{'PLAYER.altFullscreen' | translate}}"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/video-player/video-player.component.html